import React, { useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import Register from "./Register";
import { useLocation, useNavigate } from "react-router-dom";
import { validateResetPassword } from "../utils/validations";
import { GoArrowLeft } from "react-icons/go";

import { useMutation } from "@tanstack/react-query";
import ClipLoader from "react-spinners/ClipLoader";
import { toast } from "react-hot-toast";
import { API } from "../constants/api";
import { errorMessage } from "../utils/errorMessage";
import useAuthAxios from "../utils/baseAxios";
import OtpPin from "./OtpPin";

const ResetPassword = () => {
  const navigate = useNavigate();
  const axiosInstance = useAuthAxios();
  const location = useLocation();
  const info = location.state;
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [viewPassword, setViewPassword] = useState<boolean>(false);
  const [viewConfirmedPassword, setViewConfirmedPassword] =
    useState<boolean>(false);
  const [otp, setOtp] = useState<string>("");

  const handleResetPassword = async (data: any) => {
    const response = await axiosInstance.post(API.resetPassword, data);
    return response.data;
  };
  const completeResetPassword = useMutation({
    mutationFn: handleResetPassword,
    onSuccess: (r) => {
      toast.success(r.message);

      setTimeout(() => {
        navigate("/login");
      }, 2000);
    },
    onError: (error: any) => {
      toast.error(
        errorMessage((error?.data as any)?.message || String(error?.data))
      );
    },
  });

  const handleSubmit = () => {
    if (!validateResetPassword(password, confirmPassword)) {
      return;
    }
    const data = {
      email: info.email,
      otp,
      newPassword: password,
    };
    completeResetPassword.mutate(data);
  };

  return (
    <div className="w-full mds:w-4/5 md:w-3/5 xxxl:w-[50%] px-6 lgss:px-0 pt-28 pb-20 lgss:pt-16 font-manrope h-full mx-auto flex-col justify-between  items-center  flex">
      <div className="flex flex-col justify-center  items-center   w-full">
        <div className="flex justify-start items-start w-full px-4 lgss:px-8">
          <GoArrowLeft
            onClick={() => {
              navigate(-1);
            }}
            className="text-[#13181B] dark:text-gray-300 cursor-pointer text-[20px]"
          />
        </div>{" "}
        <h2 className="text-text_black w-full px-5 lgss:px-0 lgss:w-1/2 xxxl:w-2/5 dark:text-gray-200  font-sora text-2xl text-center font-bold mt-16 lgss:mt-24 lgss:pt-0 ">
          Reset your password
        </h2>
        <h4 className="text-[#617889] mt-1 dark:text-gray-300 font-manrope text-[13px] font-semibold pt-4 lgss:pt-0">
          Yaay, welcome back, please input your new password and confirm
        </h4>
        <form className="mt-6 pt-8 w-full px-5 lgss:px-0 lgss:w-1/2 xxxl:w-2/5 ">
          <OtpPin otp={otp} setOtp={setOtp} input={6} />

          <label className="relative mt-16 flex items-center ">
            <input
              type={viewPassword ? "text" : "password"}
              value={password}
              placeholder="New Password"
              onChange={(e) => setPassword(e.target.value)}
              name="password"
              className="h-[50px] dark:bg-[#1F2B36] dark:text-[white]  dark:border-[#095B97] dark:focus:bg-[#1F2B36] w-full  px-[16px] font-manrope border-2 rounded-lg border-[#4A4A68] outline-none focus:border-blue-600 text-[#4A4A68] transition duration-200"
            />

            {!viewPassword ? (
              <AiOutlineEyeInvisible
                className="text-xl -ml-10 mt-[4px] text-[#13181B] dark:text-white"
                onClick={() => setViewPassword((prev) => !prev)}
              />
            ) : (
              <AiOutlineEye
                className="text-xl -ml-10 mt-[4px] text-[#13181B] dark:text-white"
                onClick={() => setViewPassword((prev) => !prev)}
              />
            )}
          </label>
          <label className="relative mt-4  flex items-center ">
            <input
              type={viewConfirmedPassword ? "text" : "password"}
              value={confirmPassword}
              placeholder="Confirm Password"
              onChange={(e) => setConfirmPassword(e.target.value)}
              name="Confirm password"
              className="h-[50px] dark:bg-[#1F2B36] dark:text-[white]  dark:border-[#095B97] dark:focus:bg-[#1F2B36] w-full px-[16px] font-manrope border-2 rounded-lg border-[#4A4A68] outline-none focus:border-blue-600 text-[#4A4A68] transition duration-200"
            />

            {!viewConfirmedPassword ? (
              <AiOutlineEyeInvisible
                className="text-xl -ml-10 mt-[4px] text-[#13181B] dark:text-white"
                onClick={() => setViewConfirmedPassword((prev) => !prev)}
              />
            ) : (
              <AiOutlineEye
                className="text-xl -ml-10 mt-[4px] text-[#13181B] dark:text-white"
                onClick={() => setViewConfirmedPassword((prev) => !prev)}
              />
            )}
          </label>
        </form>
      </div>
      <div className="w-full mds:w-[90%] lgss:w-1/2 xxxl:w-2/5 flex flex-col justify-center items-center">
        <h4 className="font-manrope dark:text-gray-300 tracking-wider text-text_black font-medium text-[12px] pt-6">
          Don’t have an account?{" "}
          <span
            onClick={() => {
              navigate("/signup");
            }}
            className="underline text-secondary_button tracking-wider cursor-pointer"
          >
            Sign Up
          </span>
        </h4>

        <button
          onClick={handleSubmit}
          disabled={completeResetPassword.isPending}
          className="w-full  h-[52px] flex justify-center items-center font-manrope font-medium rounded-xl text-white bg-secondary_button mt-8 lgss:mt-8"
        >
          {completeResetPassword.isPending ? (
            <ClipLoader color="#FFFFFF" size={30} />
          ) : (
            "Reset Password"
          )}
        </button>
      </div>
    </div>
  );
};

const ResetPasswordPage = () => (
  <div className="lgss:flex lgss:flex-row dark:bg-[#13181B] h-screen">
    <Register />
    <ResetPassword />
  </div>
);
export default ResetPasswordPage;
